import { render, staticRenderFns } from "./DownloadOrderFormPageButton.vue?vue&type=template&id=48f3dc00&scoped=true"
import script from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"
export * from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"
import style0 from "./DownloadOrderFormPageButton.vue?vue&type=style&index=0&id=48f3dc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3dc00",
  null
  
)

export default component.exports